<div class="ui-autocomplete-field">
  @if (label()) {
    <label class="ui-autocomplete-field__label">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-autocomplete-field__required">*</span>
      }
    </label>
  }

  <div class="ui-autocomplete-field__panel">
    <input
      class="ui-autocomplete-field__control"
      type="search"
      [value]="value()"
      [placeholder]="placeholder() | uiLabelTranslate"
      [readOnly]="readonly()"
      [disabled]="disabled()"
      (input)="onValueChange(control.value)"
      (focus)="open()"
      (blur)="close()"
      #control
    />

    @if (isOpen && (loading() || options().length > 0 || (value().trim().length >= 3 && !loading()))) {
      <div class="ui-autocomplete-field__menu">
        @if (loading()) {
          <p class="ui-autocomplete-field__state">{{ 'Searching addresses...' | uiLabelTranslate }}</p>
        } @else if (options().length === 0) {
          <p class="ui-autocomplete-field__state">{{ emptyMessage() | uiLabelTranslate }}</p>
        } @else {
          @for (option of options(); track option.value) {
            <button class="ui-autocomplete-field__option" type="button" (click)="selectOption(option.value)">
              <span class="ui-autocomplete-field__option-label">{{ option.label }}</span>
              @if (option.caption) {
                <span class="ui-autocomplete-field__option-caption">{{ option.caption }}</span>
              }
            </button>
          }
        }
      </div>
    }
  </div>

  @if (error()) {
    <p class="ui-autocomplete-field__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-autocomplete-field__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
